import { ITask } from "../../services";

class TaskListController implements ng.IComponentController {
    private sortType: string;
    private search: string;
    private tasks: ITask[];
    private filteredTasks: ITask[];
    private selectedStatus: string;

    constructor(private $filter: any) {
        'ngInject';
    }

    public $onInit = () => {
        this.sortType = 'date';
        this.filter();
    }

    filter() {
        this.filteredTasks = this.$filter('filterBy')(this.tasks, ['taskStatusName'], this.selectedStatus);
    }
}

export const taskListComponent = {
    bindings: {
        tasks: '<',
        taskStatuses: '<'
    },
    controller: TaskListController,
    template: require('./task.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/tasks/task.list.component.ts